import Lib from '../../../commons/lib';

export default class Service {
  static ugyfelszolgalatUrl = window.location.origin + '/api/ugyfelszolgalat/';

  static szervezetUrl = window.location.origin + '/api/szervezet/';

  // ÁLLAPOT START

  static listAllapot(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'allapot/list',
      args: { requestType: 'allapot-list' }
    }], fnDone);
  }

  static addAllapot(allapot, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.ugyfelszolgalatUrl + 'allapot',
      args: { requestType: 'allapot-post' },
      data: allapot
    }], fnDone);
  }

  static editAllapot(allapot, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'allapot',
      args: { requestType: 'allapot-put' },
      data: allapot,
    }], fnDone);
  }

  static getAllapot(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'allapot',
      args: { requestType: 'allapot-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteAllapot(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.ugyfelszolgalatUrl + 'allapot',
      args: { requestType: 'allapot-delete' },
      params: { id: id }
    }], fnDone);
  }

  // ÁLLAPOT END

  // ESETTÍPUS START

  static listEsettipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'esettipus/list',
      args: { requestType: 'esettipus-list' }
    }], fnDone);
  }

  static addEsettipus(allapot, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.ugyfelszolgalatUrl + 'esettipus',
      args: { requestType: 'esettipus-post' },
      data: allapot
    }], fnDone);
  }

  static editEssettipus(allapot, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'esettipus',
      args: { requestType: 'esettipus-put' },
      data: allapot,
    }], fnDone);
  }

  static getEsettipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'esettipus',
      args: { requestType: 'esettipus-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteEsettipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.ugyfelszolgalatUrl + 'esettipus',
      args: { requestType: 'esettipus-delete' },
      params: { id: id }
    }], fnDone);
  }

  // ESETTÍPUS END

  // ELÉRHETŐSÉG START

  static listElerhetoseg(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'elerhetoseg/list',
      args: { requestType: 'elerhetoseg-list' }
    }], fnDone);
  }

  static initElerhetoseg(id, isView, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'elerhetoseg/init',
      args: { requestType: 'elerhetoseg-get' },
      params: { id: id, view: isView }
    }], fnDone);
  }

  static addElerhetoseg(elerhetoseg, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.ugyfelszolgalatUrl + 'elerhetoseg',
      args: { requestType: 'elerhetoseg-post' },
      data: elerhetoseg
    }], fnDone);
  }

  static editElerhetoseg(elerhetoseg, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'elerhetoseg',
      args: { requestType: 'elerhetoseg-put' },
      data: elerhetoseg,
    }], fnDone);
  }

  static deleteElerhetoseg(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.ugyfelszolgalatUrl + 'elerhetoseg',
      args: { requestType: 'elerhetoseg-delete' },
      params: { id: id }
    }], fnDone);
  }

  static initForm(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'esettipus/init',
      args: { requestType: 'esettipus-init-get' },
      params: { id: id }
    }], fnDone);
  }

  // ELÉRHETŐSÉG END

}
